import { createContext } from "react";

interface PortalContext {
  isPortal: boolean;
}

const PortalContext = createContext<PortalContext>({
  isPortal: true,
});

export default PortalContext;
